import React from 'react'
/**
* @About
* This file contains all type of validation.
*/

/* To handle first name validation*/
export function validateName(name) {
    var nameRegex = /^[a-zA-Z ]{2,200}$/;
    // /^[a-zA-Z]+$/;

    console.log(name,"Fffffffffffffffff")
    var name = name.trim();
    if (!name.replace(/\s/g, '').length) {
        return { status: false, error: "*Please enter valid name" };
    }
    if (name === "" || name === undefined || name === null) {
        return { status: false, error: "*Please enter your name" };
    }
    else if (!nameRegex.test(name)) {
        return { status: false, error: "*Please provide valid name" };
    }
    else if (name.length < 2) {
        return { status: false, error: "*Please provide valid name" }
    }
    else {
        return { status: true, error: '' };
    }
}
export function validateVatNumber(vat) {
    if (vat === "" || vat === undefined || vat === null) {
        return { status: false, error: "*Please enter your VAT number" };
    }
    else if (vat.length < 8) {
        return { status: false, error: "*Please provide valid VAT number" }
    }
    else {
        return { status: true, error: '' };
    }
}
export function validateYear(year) {
    const yearRegex = /^\d{4}$/;
    if (year === "" || year === undefined || year === null) {
        return { status: false };
    }
    else if (year.length < 4 || year.length > 4) {
        return { status: false }
    }
    else if (!yearRegex.test(year)) {
        return { status: false, error: false }
    }
    else {
        return { status: true, error: true };
    }
}

export function validateCarId(CarId) {
    if (CarId === "" || CarId === undefined || CarId === null) {
        return { status: false };
    }
    else {
        return { status: true };
    }
}


export function validateTerms(terms) {
    
    var termsRegex = /^[a-zA-Z ]{2,30}$/;
    if (terms === "" || terms === undefined || terms === null) {
        return { status: false, error: "*Please enter your name" };
    }
    else if (!termsRegex.test(terms)) {
        return { status: false, error: "*Please provide valid name" };
    }
    else if (terms.length < 2) {
        return { status: false, error: "*Please provide valid name" }
    }
    else {
        return { status: true, error: '' };
    }
}

// / To handle email validation /
export function validateEmail(email) {
    var emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/;
    // email = email.trim();
    if (email === "" || email === undefined || email === null) {
        return { status: false, error: "*Please enter email address." };
    }
    else if (!emailRegex.test(email)) {
        return { status: false, error: "*Please enter valid email address." };
    }
    else {
        return { status: true, error: '' };
    }
}
// / To validate password /

export function validatePassword(password) {
    // console.log(password, 'dasadasdasdddsdsa');
    // var passwordRegex = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{16,}$/;
    // var passwordRegex = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/;
    // var passwordRegex = /^ (?=^.{8,16}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
    // var passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$/;
    let passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    //password = password.trim();

    if (password === "" || password === undefined || password === null) {
        return { status: false, error: "Please enter valid password." }
    }
    // else if (!passwordRegex.test(password)) {
    // return { status: false, error: "Please enter valid password." };
    // }
    else if (password.length < 8) {
        return { status: false, error: "Password must have at least 8 characters with at least one Capital letter, at least one lower case letter and at least one number." };
    }
    // else if(password.length > 8||password.length ===8){
    // return { status: false, error: "Passwocters." };
    // }
    else if (!passwordRegex.test(password)) {
        return { status: false, error: "Password must have at least 8 characters with at least one Capital letter, at least one lower case letter and at least one number." }
    }
    else {
        return { status: true, error: '' }
    }
}

// / To validate Mobile No. /

export function validateMobileNo(mobileNo) {
    var numberRegex = /^[+][1-9][0-9]{7,18}$/;
    mobileNo = mobileNo.trim()
    if (mobileNo === "") {
        return { status: true, error: "" }
    }
    if (mobileNo === "" || mobileNo === undefined || mobileNo === null || mobileNo.length < 10) {
        return { status: false, error: "*Please enter phone number." }
    }
    else if (!numberRegex.test(mobileNo)) {
        return { status: false, error: "*Please enter valid phone number (+1XXXXXXXXXX)." }
    } else {
        return { status: true, error: '' }
    }
}

//first lettter caps
export function firstLetterCaps(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function validateMobileNo1(mobileNo) {
    var numberRegex = /^[0-9][0-9]{7,20}$/;
    mobileNo = mobileNo.trim()
    if (mobileNo === "") {
        return { status: true, error: "" }
    }
    if (mobileNo === undefined || mobileNo === null) {
        return { status: false, error: "*Please enter phone number." }
    } else if (!numberRegex.test(mobileNo)) {
        return { status: false, error: "*Please enter valid phone number." }
    } else {
        return { status: true, error: '' }
    }
}

export function CardValidation(cardNumber) {
    var numberRegex = /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;;
    cardNumber = cardNumber.trim()
    if (cardNumber === "") {
        return { status: true, error: "" }
    }
    if (cardNumber === undefined || cardNumber === null) {
        return { status: false, error: "*Please enter phone number." }
    } else if (!numberRegex.test(cardNumber)) {
        return { status: false, error: "*Please enter valid phone number." }
    } else {
        return { status: true, error: '' }
    }
}

